import React, { MouseEventHandler } from 'react';
import { GridState } from '../../utils';
import Cell from '../Cell';

import styles from './styles.module.css';

interface GridProps {
  state: GridState;
  onCellClick: MouseEventHandler<HTMLDivElement>;
}

const Grid = (props: GridProps) => {
  return (
    <div className={styles['grid']}>
      {props.state.map((rowValue, rowIndex) =>
        rowValue.map((colValue, colIndex) =>
          <Cell key={`r${rowIndex}c${colIndex}}`} row={rowIndex} col={colIndex} mark={colValue} onClick={props.onCellClick} />
      ))}
    </div>
  );
};

export default Grid;